<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :md="12">
        <MetaSection :title="kpi?.title || '-'">
          <div class="d-flex gap-3">
            <router-link :to="{ name: 'Laporan Gabungan' }">
              <button class="btn btn-secondary">
                Kembali
              </button>
            </router-link>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :md="12">
        <form>
          <div class="d-flex flex-row gap-2">
            <FormGroup>
              <select name="unitkerja" id="unitkerja" v-model="params.unitkerja_id" class="form-control">
                <option value="">Semua Unit Kerja</option>
                <option v-for="(item, index) in unitkerja" :key="index" :value="item.id">{{ item.name }}</option>
              </select>
            </FormGroup>
            <!-- <FormGroup>
              <select name="posisi" id="posisi" v-model="params.jabatan_id" class="form-control">
                <option value="">Semua Jabatan</option>
                <option v-for="(item, index) in jabatan" :key="index" :value="item.id">{{ item.name }}</option>
              </select>
            </FormGroup> -->
          </div>
        </form>
      </GridCol>

      <!-- <GridCol :md="12" class="mb-5">
        <GridRow>
          <GridCol :md="3">
            <CardComponent :withmin="false">
              <DoughnutChart
                v-if="kpi?.chart"
                :v_id="`chart_detail_kpi_gabungan_${Math.floor(Math.random() * 1000) + 1}`"
                :width="150"
                :height="150"
                :labels="kpi?.chart?.label ? mapLabels(kpi?.chart?.label) : []"
                :chartData="kpi?.chart?.data || []"
                :color="['#52cb58', '#e3f9e6']"
                :isShowMaxValue="true"
              />
            </CardComponent>
          </GridCol>

          <GridCol :md="9">
            <GridRow>
              <GridCol :md="6">
                <CardComponent>
                  <div class="d-flex flex-column w-100 gap-3">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16" cy="16" r="16" fill="#ECF4FF"/>
                      <path d="M22.9504 9.56521H9.03736C8.75215 9.56521 8.51562 9.32869 8.51562 9.04347C8.51562 8.75825 8.75215 8.52173 9.03736 8.52173H22.9504C23.2356 8.52173 23.4721 8.75825 23.4721 9.04347C23.4721 9.32869 23.2356 9.56521 22.9504 9.56521Z" fill="#0385F3"/>
                      <path d="M19.2421 23.1931C19.1516 23.3739 18.9638 23.4783 18.776 23.4783C18.6995 23.4783 18.616 23.4574 18.5464 23.4226L15.9934 22.1496L13.4403 23.4226C13.3708 23.4574 13.2873 23.4783 13.2108 23.4783C13.023 23.4783 12.8351 23.3739 12.7447 23.1931C12.6125 22.9287 12.7169 22.6157 12.9812 22.4904L15.4716 21.2452V19.4783H16.5151V21.2452L19.0056 22.4904C19.2699 22.6157 19.3743 22.9287 19.2421 23.1931Z" fill="#0385F3"/>
                      <path d="M9.73438 9.04346V17.4608C9.73438 18.7826 10.43 19.4782 11.7518 19.4782H20.2387C21.5605 19.4782 22.2561 18.7826 22.2561 17.4608V9.04346H9.73438ZM19.4596 13.6208L17.2683 15.4504C17.0665 15.6174 16.8092 15.6869 16.5657 15.6452C16.3152 15.6035 16.0996 15.4504 15.9674 15.2278L15.237 14.0104L13.1987 15.7078C13.1013 15.7913 12.9831 15.8261 12.8648 15.8261C12.7187 15.8261 12.5657 15.7635 12.4613 15.6382C12.2735 15.4156 12.3083 15.0887 12.5309 14.9008L14.7222 13.0713C14.9239 12.9043 15.1813 12.8348 15.4248 12.8765C15.6752 12.9182 15.8909 13.0713 16.0231 13.2939L16.7535 14.5113L18.7918 12.8139C19.0144 12.6261 19.3413 12.6608 19.5292 12.8835C19.71 13.1061 19.6822 13.433 19.4596 13.6208Z" fill="#0385F3"/>
                    </svg>
                    <span class="text-lg">Target</span>
                    <h3 class="fw-bold mt-6">
                      {{
                        new Intl.NumberFormat('id-ID', {
                          style: 'currency',
                          currency: 'IDR',
                          minimumFractionDigits: 0,
                        }).format(10000000 || '0')
                      }}
                    </h3>
                  </div>
                </CardComponent>
              </GridCol>
              <GridCol :md="6">
                <CardComponent>
                  <div class="d-flex flex-column w-100 gap-3">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16" cy="16" r="16" fill="#ECF4FF"/>
                      <path d="M18.9104 9.04346H13.0808C10.5486 9.04346 9.03906 10.553 9.03906 13.0852V18.9148C9.03906 21.4469 10.5486 22.9565 13.0808 22.9565H18.9104C21.4425 22.9565 22.9521 21.4469 22.9521 18.9148V13.0852C22.9521 10.553 21.4425 9.04346 18.9104 9.04346ZM14.5834 18.0174L13.0182 19.5826C12.9138 19.6869 12.7817 19.7356 12.6495 19.7356C12.5173 19.7356 12.3782 19.6869 12.2808 19.5826L11.7591 19.0608C11.5504 18.8591 11.5504 18.5252 11.7591 18.3235C11.9608 18.1217 12.2878 18.1217 12.4965 18.3235L12.6495 18.4765L13.846 17.28C14.0478 17.0782 14.3747 17.0782 14.5834 17.28C14.7851 17.4817 14.7851 17.8156 14.5834 18.0174ZM14.5834 13.1478L13.0182 14.713C12.9138 14.8174 12.7817 14.8661 12.6495 14.8661C12.5173 14.8661 12.3782 14.8174 12.2808 14.713L11.7591 14.1913C11.5504 13.9895 11.5504 13.6556 11.7591 13.4539C11.9608 13.2522 12.2878 13.2522 12.4965 13.4539L12.6495 13.6069L13.846 12.4104C14.0478 12.2087 14.3747 12.2087 14.5834 12.4104C14.7851 12.6122 14.7851 12.9461 14.5834 13.1478ZM19.8634 19.2139H16.2112C15.926 19.2139 15.6895 18.9774 15.6895 18.6922C15.6895 18.4069 15.926 18.1704 16.2112 18.1704H19.8634C20.1556 18.1704 20.3851 18.4069 20.3851 18.6922C20.3851 18.9774 20.1556 19.2139 19.8634 19.2139ZM19.8634 14.3443H16.2112C15.926 14.3443 15.6895 14.1078 15.6895 13.8226C15.6895 13.5374 15.926 13.3008 16.2112 13.3008H19.8634C20.1556 13.3008 20.3851 13.5374 20.3851 13.8226C20.3851 14.1078 20.1556 14.3443 19.8634 14.3443Z" fill="#0385F3"/>
                    </svg>

                    <span class="text-lg">Realisasi</span>
                    <h3 class="fw-bold mt-6">
                      {{
                        new Intl.NumberFormat('id-ID', {
                          style: 'currency',
                          currency: 'IDR',
                          minimumFractionDigits: 0,
                        }).format(10000000 || '0')
                      }}
                    </h3>
                  </div>
                </CardComponent>
              </GridCol>
            </GridRow>
          </GridCol>
        </GridRow>
      </GridCol> -->

      <GridCol :md="12">
        <MetaSection title="Sub KPI"></MetaSection>
        <GridRow v-if="kpi?.sub?.length > 0">
          <GridCol :md="6"
            v-for="(item, index) in kpi.sub"
            :key="index"
            class="mb-4"
          >
            <RealisasiGabunganCard
              :kpi="item"
              :detail_list_sub="false"
              detail_type="kpi_detail"
              :index_kpi="index"
            />
          </GridCol>
        </GridRow>

        <p v-else class="text-center p-6">Data tidak ditemukan.</p>
      </GridCol>

    </GridRow>
  </div>
</template>

<style scoped>
li::marker {
  display: none;
}

li:first-child::before {
  content: "\2022";
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
  color: #0385F3 !important;
}
</style>

<script>
// import PerformanceHistoryChart from "../examples/Charts/PerformanceHistoryChart.vue";
// import Cards from "../components/CardComponent.vue";
// import CardComponent from "@/components/CardComponent.vue";
import RealisasiGabunganCard from "@/components/RealisasiGabunganCard.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import MetaSection from "@/components/MetaSection.vue";
import FormGroup from '@/components/FormGroup.vue';
// import DoughnutChart from "@/components/DoughnutChart.vue";

import JabatanApi from '@/repository/api/JabatanApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
// import KpiApi from "@/repository/api/KpiApi";
import LaporanGabunganApi from '@/repository/api/LaporanGabunganApi';

export default {
  name: "dashboard-default",
  components: {
    RealisasiGabunganCard,
    GridRow,
    GridCol,
    MetaSection,
    FormGroup,
    // CardComponent,
    // DoughnutChart,
  },
  data() {
    return {
      kpi: [],
      unitkerja: [],
      jabatan: [],
      params: {
        unitkerja_id: "",
        // jabatan_id: "",
        // page: 1,
      },
      labels: {
        belum_dikerjakan: 'Belum Terealisasi',
        sudah_dikerjakan: 'Sudah Terealisasi',
      },
    };
  },
  watch: {
    // 'params': {
    //   handler: async function () {
    //     this.params.page = 1;
    //     this.params.jabatan_id = "";
    //     await this.getDetailKpi();
    //   },
    //   deep: true,
    // },
    'params.unitkerja_id': {
      handler: async function () {
        // await this.getJabatan();
        await this.getDetailKpi();
      },
      deep: true,
    }
  },
  methods: {
    async getUnitKerja() {
      this.$store.state.loading = true;

      await UnitKerjaApi.getbyparam({
        page: 'all',
      })
      .then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    
    async getJabatan() {
      this.$store.state.loading = true;
      let params = {
        page: 'all',
      };

      if (this.params.unitkerja_id != "") {
        // params = {
        //   unitkerja_id: this.params.unitkerja_id,
        // }
        params.unitkerja_id = this.params.unitkerja_id;
      }
      await JabatanApi.getbyparam(params)
        .then((response) => {
          this.jabatan = response.data;
        }).catch(() => {
          this.jabatan = [];
        });

      this.$store.state.loading = false;
    },

    async getDetailKpi() {
      this.$store.state.loading = true;
      await LaporanGabunganApi.getDetailKpi(this.params)
        .then((response) => {
          this.kpi = response?.data;
        }).catch(() => {
          this.kpi = [];
        });
      this.$store.state.loading = false;
    },

    mapLabels(labels) {
      return labels.map(item => this.labels?.[item] || item || '-')
    },
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getUnitKerja();
    // await this.getJabatan();
    this.params.id = this.$route.params?.kpi_id;
    await this.getDetailKpi();
    this.$store.state.loading = false;
  },
};
</script>
